import { Avatar, Button, Card, Collapse, Input, List, Space } from "antd";
import { Comment } from "@ant-design/compatible";
import React, { useContext, useRef, useState } from "react";
import { useEffect } from "react";
import { FaUser } from "react-icons/fa";
import { isAuthenticated } from "../../../Auth/auth";
import { renderFile } from "../../../Chats/renderFile";
import DeleteModal from "../../../DeleteModal/DeleteModal";
import { SocketContext } from "../../../../context/SocketContext";

import { useTranslation } from "react-i18next";
const DocumentCard = ({ milestone, doc }) => {
  const { t } = useTranslation("dashboard");
  const socket = useContext(SocketContext);
  const messagesEndRef = useRef(null);
  const [inputText, setInputText] = useState("");

  const scrollToBottom = () => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    scrollToBottom();

    return () => {};
  }, [doc]);

  const deleteDoc = async id => {
    if (id) {
      socket.emit("deleteDocument", { id });
    }
  };

  const addComment = async (docId, newComment) => {
    socket.emit("addCommentToDocument", { comment: newComment, documentId: docId });
    setInputText("");
  };

  return (
    <div className="milestone-doc">
      <Card className="w-100">
        <div>
          <div className="milestone-doc__toolbar">
            <DeleteModal text="Document" onClick={() => deleteDoc(doc?._id)} />
          </div>
          <div className="milestone-doc__file">{renderFile(doc?.file)}</div>
          <p className="milestone-doc__message">{doc?.message}</p>
          {doc?.comments?.length > 0 && (
            <Collapse accordion>
              <Collapse.Panel header={`${t("Comments")} (${doc?.comments?.length})`} key="1">
                <List
                  style={{ maxHeight: "400px", overflowY: "auto" }}
                  header={t("Comments")}
                  dataSource={doc?.comments || []}
                  renderItem={item => {
                    let getUser = milestone?.team?.filter(t => t?._id === item?.sender)[0];
                    let sender;
                    if (getUser?._id) {
                      sender = getUser?.firstName + " " + getUser?.lastName;
                    } else if (item?.sender === isAuthenticated()?.serviceProviderId) {
                      sender = isAuthenticated()?.firstName + " " + isAuthenticated()?.lastName;
                    }

                    return (
                      <div ref={messagesEndRef}>
                        <Comment
                          avatar={<Avatar icon={<FaUser />} />}
                          author={sender && sender}
                          content={item?.comment}
                        />
                      </div>
                    );
                  }}
                />
              </Collapse.Panel>
            </Collapse>
          )}
          <Space.Compact className="milestone-doc__comment">
            <Input
              allowClear
              onChange={e => setInputText(e.target.value)}
              value={inputText}
              placeholder={t("Comment here....")}
              aria-label={t("Comment here....")}
            />
            <Button type="primary" onClick={() => addComment(doc?._id, inputText)}>
              {t("Add Comment")}
            </Button>
          </Space.Compact>
        </div>
      </Card>
    </div>
  );
};

export default DocumentCard;
